import axios from "axios";
import apilist from "../../apilist.json";
import { CONFIG } from "../../Config/";
import md5 from "md5";
import dayjs from "dayjs";
import { toast } from "react-toastify";


export const _IMAPI = {

    DATA: {},
    APILIST: {},
    geoLocation: null,

    getService: function (apiurl) {
        return apilist[apiurl]
    },

    getURL: function (uriComponent, urlParams) {

        if (uriComponent?.charAt(0) === "/") {
        } else if (uriComponent.substr(0, 7) === "http://" ||
            uriComponent.substr(0, 8) === "https://" ||
            uriComponent.substr(0, 6) === "ftp://") {

            return uriComponent;
        } else {
            if (_IMAPI.APILIST[uriComponent] === null) {
                return false;
            }
            uriComponent = _IMAPI.APILIST[uriComponent];

        }

        if (urlParams !== null && typeof urlParams === "object") {

            Object.keys(urlParams).forEach(function (a) {
                let value = urlParams[a];
                if (uriComponent.indexOf(":" + a) > -1) {
                    uriComponent = uriComponent.replace(":" + a, value);
                    delete urlParams[a];
                }
            });

            return CONFIG["CONFIG"]["" + CONFIG['appstatus']]['API_URL'] + uriComponent

        } else if (urlParams !== null && typeof urlParams === "string" && urlParams.length > 1) {
            return CONFIG["CONFIG"]["" + CONFIG['appstatus']]['API_URL'] + uriComponent + "?" + urlParams;
        } else {
            return CONFIG["CONFIG"]["" + CONFIG['appstatus']]['API_URL'] + uriComponent;
        }
    },

    generateDataHash: function (dataObj) {

        if (dataObj === null || typeof dataObj != "object" || Array.isArray(dataObj)) return "";
        let apISecret = CONFIG['appstatus'] === "production" ? process.env.REACT_APP_API_SECRET_PRODUCTION :
            CONFIG['appstatus'] === "beta" ? process.env.REACT_APP_API_SECRET_BETA :
                CONFIG['appstatus'] === "development" ? process.env.REACT_APP_API_SECRET_DEVELOPMENT : "";

        return md5(JSON.stringify(dataObj) + apISecret);
    },

    getHeaders: function () {

        let apiKey = CONFIG['appstatus'] === "production" ? process.env.REACT_APP_API_KEY_PRODUCTION :
            CONFIG['appstatus'] === "beta" ? process.env.REACT_APP_API_KEY_BETA :
                CONFIG['appstatus'] === "development" ? process.env.REACT_APP_API_KEY_DEVELOPMENT : "";

        const headers = {
            'Authorization': "Bearer " + apiKey
        };

        const authToken = localStorage.getItem("AUTH_TOKEN");

        if (authToken) {
            headers['auth-token'] = localStorage.getItem("AUTH_TOKEN");
        }

        return headers;
    },


    fetchGeoLocation: async function () {

        if (navigator.geolocation) {

            try {
                const position = await new Promise((resolve, reject) => {
                    navigator.geolocation.getCurrentPosition(resolve, reject, {
                        enableHighAccuracy: true,  // High accuracy setting
                        timeout: 10000,            // Timeout after 10 seconds if location not found
                        maximumAge: 0              // Do not use cached location (force fresh position)
                    })
                });
                const { latitude, longitude } = position.coords;
                const geolocation = latitude + "," + longitude;
                return geolocation
            } catch (error) {

                throw new Error("Geolocation must be enabled to login on this portal");

            }


        } else {

            throw new Error("Geolocation is not supported by this browser hence you can not access this portal");

        }
    },



    _GET: function (uri, urlParams, qParams, callback, errorCallback, dataType) {

        if (!dataType) dataType = "json";

        const lxURL = _IMAPI.getURL(uri, urlParams);

        if (lxURL === false) {
            return errorCallback(false);
        }
        axios({
            method: "get",
            url: lxURL,
            params: qParams,
            responseType: dataType,
            headers: Object.assign(_IMAPI.getHeaders(), {
                "x-data-hash": _IMAPI.generateDataHash({})
            })
        }).then(function (data) {

            return callback(data);
        }).catch(function (err) {
            let data = err.response ? err.response.data : err;
            if (data?.code === "Unauthorized") {
                toast.error(data?.message || data?.code);
                _IMAPI.geoLocation = null
                localStorage.clear();
                let timerID = setTimeout(() => {
                    window.location.href = "/";
                    clearTimeout(timerID)
                }, 2000);

            }
            if (errorCallback) {
                return errorCallback(err)
            }

        }).finally(function (txt) {
        });

    },

    AXIOS_POST: function (geolocation, body, url, responseType, callback, errorCallback) {

        if (!body) body = {};
        let headers = _IMAPI.getHeaders();

        body = Object.assign({
            geolocation: geolocation,
            userid: localStorage.getItem("CURRENT_USERID"),
            clientip: localStorage.getItem("CURRENT_CLIENTIP"),
            medium: 'rweb',
            site: 'mapp',
            host: CONFIG['URL'].split("://")[1],
            timestamp: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        }, body);

        axios({
            method: "post",
            url: url,
            responseType,
            data: body,

            headers: Object.assign(headers, {
                "x-data-hash": _IMAPI.generateDataHash(body),
            })
        }).then(function (data) {

            return callback(data);
        }).catch(function (err) {

            let data = err.response ? err.response.data : err;

            if (data?.code === "Unauthorized") {
                toast.error(data.message);
                _IMAPI.geoLocation = null;
                sessionStorage.clear();
                localStorage.clear();
                let timerID = setTimeout(() => {
                    window.location.href = "/";
                    clearTimeout(timerID)
                }, 2000);

            }
            if (errorCallback) {
                return errorCallback(err);
            }


        }).finally(function (txt) {
        });

    },

    _POST: function (uri, urlParams, body, callback, errorCallback, responseType) {

        if (!responseType) responseType = "json";

        const lxURL = _IMAPI.getURL(uri, urlParams);

        if (lxURL === false) {
            return errorCallback(false);
        }

        if (_IMAPI.geoLocation) {

            _IMAPI.AXIOS_POST(_IMAPI.geoLocation, body, lxURL, responseType, callback, errorCallback);

        } else {

            _IMAPI.fetchGeoLocation().then((geolocation) => {

               _IMAPI.geoLocation = geolocation;

            _IMAPI.AXIOS_POST(geolocation, body, lxURL, responseType, callback, errorCallback);


            }).catch((error) => {
                _IMAPI.geoLocation = null;
                alert(error.message);
                return errorCallback(false);
            })
        }


    }
}
